var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToDock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H25L32 4V32H7L0 28V0Z",
  fill: "#C7DAF9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0007 8.5C11.8585 8.5 8.50068 11.8579 8.50068 16C8.50068 16.2047 8.50886 16.4073 8.52488 16.6075L9.75752 15.0298L11.3335 16.2612L8.72157 19.6043C8.38156 20.0395 7.75312 20.1167 7.31792 19.7767L3.97461 17.1647L5.2059 15.5887L6.52034 16.6156C6.5073 16.412 6.50068 16.2067 6.50068 16C6.50068 10.7533 10.754 6.5 16.0007 6.5C18.9034 6.5 21.5028 7.80306 23.2438 9.85258L21.7195 11.1474C20.3423 9.52612 18.2918 8.5 16.0007 8.5Z",
  fill: "#1B1B1B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.481 15.3843L26.7955 16.4112L28.0267 14.8351L24.6835 12.2232C24.2483 11.8832 23.6198 11.9604 23.2798 12.3956L20.6678 15.7387L22.2438 16.9701L23.4765 15.3924C23.4925 15.5927 23.5007 15.7953 23.5007 16C23.5007 20.1421 20.1428 23.5 16.0007 23.5C13.7096 23.5 11.6591 22.4739 10.2819 20.8526L8.75758 22.1474C10.4986 24.1969 13.098 25.5 16.0007 25.5C21.2474 25.5 25.5007 21.2467 25.5007 16C25.5007 15.7932 25.4941 15.5879 25.481 15.3843Z",
  fill: "#1B1B1B"
})));
export { SvgToDock as ReactComponent };
export default __webpack_public_path__ + "assets/29d8b40b.svg";